import React from 'react'

import styles from './Warning.module.scss'

const Warning = () => {
  return (
    <div className={styles.info}>
      <p>Недостатньо старсів</p>
    </div>
  )
}

export default Warning
